import React, { Fragment, FunctionComponent } from "react";

import { DropdownItem, DropdownSeparatorItem, DropdownSkeletonItem } from "@multiweb/dropdown";
import { IWorkflowMenuItem } from "@multiweb/types/multiweb";

const renderWorkflowActionItems = (workflowActions: IWorkflowMenuItem[], executeAction: (workflowActionId: string) => void) => {
    if (workflowActions && workflowActions.length > 0) {
        const items = workflowActions?.map(action =>
            <DropdownItem
                key={action.ID}
                clickAction={{
                    title: action.Codename,
                    text: action.ItemName,
                    onClick: () => executeAction(action.ID),
                }} />,
        );
        items.unshift(<DropdownSeparatorItem key="dropdown-separator-item" />);
        return items;
    }
    return [];
};

export type WorkflowActionsComponentProps = {
    /** Workflow akce a jejich vlastnosti */
    workflowActions?: IWorkflowMenuItem[];
    /** Příznak, zda jsou workflow akce načítány */
    isLoading: boolean;
    /** Funkce, jejiž volání zajistí provedení akce */
    executeAction: (workflowActionId: string) => void;
};

export const WorkflowActionItemsComponent: FunctionComponent<WorkflowActionsComponentProps> = ({
    workflowActions,
    isLoading,
    executeAction,
}) => {
    return (
        <Fragment>
            { isLoading ? <Fragment>
                <DropdownSeparatorItem />
                <DropdownSkeletonItem />
            </Fragment> : renderWorkflowActionItems(workflowActions || [], executeAction) }
        </Fragment>
    );
};
